import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import PortfolioForm from '@components/portfolio/PortfolioForm';
import { ArrowLeft } from 'lucide-react';

const PortfolioSetup = () => {
  const navigate = useNavigate();

  const handleSuccess = () => {
    navigate('/dashboard');
  };

  const handleCancel = () => {
    navigate(-1);
  };

  return (
    <div className="min-h-screen bg-gray-50 py-8 px-4">
      <div className="max-w-4xl mx-auto">
        <button
          onClick={() => navigate(-1)}
          className="flex items-center gap-2 text-gray-600 hover:text-gray-900 mb-6 transition-colors"
        >
          <ArrowLeft className="w-5 h-5" />
          Back
        </button>

        <PortfolioForm onClose={handleCancel} onSuccess={handleSuccess} />
      </div>
    </div>
  );
};

export default PortfolioSetup;
